import React, { useEffect, useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import Races from "./components/race/Races";
import ResultPage from "./components/results/ResultPage";
import { useLocation } from "react-router-dom";
import apiService from "./services/apiService";
import EventOperations from "./services/EventOperations";
import { RaceDTO } from "./interfaces/RaceDTO";
import Loading from "./loader/Loading";
import { FavoritesProvider } from "./services/FavoritesProvider";
import { BladeProvider, useBlade } from "./services/BladeProvider";
import CookieConfirmation from "./components/Tools/CookieConfirmation";
import AppInside from "./AppInside";

function App() {
  useEffect(() => {
    const getVersion: string | null = localStorage.getItem("version");

    if (getVersion === null) {
      for (var key in localStorage) {
        if (key.includes("saved_race"))
        {
          localStorage.removeItem(key);
        }
      }
    } else if (getVersion === "1.0") {
      for (var key in localStorage) {
        if (key.includes("saved_race"))
        {
          localStorage.removeItem(key);
        }
      }
    }

    localStorage.setItem("version", "1.1");
  }, []);

  return (
    // <div className="App nsf-design">
    <div className="App">
      <BladeProvider>
        <AppInside />
      </BladeProvider>
    </div>
  );
}

export default App;
